import {
    useEffect,
    useState
} from 'react';

import {
    getAppContents,
    insertAppContent,
    updateAppContent,
    deleteAppContent
} from '../../../api/adminApi';

import './AppContentManage.css';

interface AppContent {

    id: number;

    title: string;

    imageUrl: string;

    youtubeUrl: string;

    category: string;

    content: string;
}

const AppContentManage = () => {

    const [contents, setContents] =
        useState<AppContent[]>([]);

    const [form, setForm] =
        useState({

            youtubeUrl: ''
        });

    const [showModal, setShowModal] =
        useState(false);

    const [editItem, setEditItem] =
        useState<AppContent | null>(null);

    useEffect(() => {

        loadContents();

    }, []);

    const loadContents = async () => {

        const response =
            await getAppContents();

        setContents(response.data);
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        setForm({

            ...form,

            [e.target.name]:
            e.target.value
        });
    };

    const handleInsert = async () => {

        await insertAppContent({

            title: '신규',

            imageUrl: '',

            youtubeUrl:
            form.youtubeUrl,

            category: '',

            content: ''
        });

        setForm({

            youtubeUrl: ''
        });

        loadContents();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                '삭제하시겠습니까?'
            )
        ) {

            return;
        }

        await deleteAppContent(id);

        loadContents();
    };

    const handleEdit = (
        item: AppContent
    ) => {

        setEditItem(item);

        setShowModal(true);
    };

    const handleSave = async () => {

        if (!editItem) {

            return;
        }

        await updateAppContent(

            editItem.id,

            {

                title:
                editItem.title,

                imageUrl:
                editItem.imageUrl,

                youtubeUrl:
                editItem.youtubeUrl,

                category:
                editItem.category,

                content:
                editItem.content
            }
        );

        setShowModal(false);

        setEditItem(null);

        loadContents();
    };

    return (

        <div className="app-content-manage">

            <h2>
                앱 게시물 관리
            </h2>

            <div className="app-content-form">

                <input
                    name="youtubeUrl"
                    placeholder="유튜브 URL 입력"
                    value={form.youtubeUrl}
                    onChange={handleChange}
                />

                <button
                    onClick={handleInsert}
                >
                    등록
                </button>

            </div>

            <div className="app-content-list">

                {
                    contents.map(item => (

                        <div
                            key={item.id}
                            className="app-content-card"
                        >

                            <img
                                src={item.imageUrl}
                                alt={item.title}
                                className="app-thumbnail"
                            />

                            <h4>
                                {item.title}
                            </h4>

                            <div
                                className="app-content-actions"
                            >

                                <button
                                    className="edit-btn"
                                    onClick={() =>
                                        handleEdit(
                                            item
                                        )
                                    }
                                >
                                    수정
                                </button>

                                <a
                                    href={
                                        item.youtubeUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    영상 보기
                                </a>

                                <button
                                    className="delete-btn"
                                    onClick={() =>
                                        handleDelete(
                                            item.id
                                        )
                                    }
                                >
                                    삭제
                                </button>

                            </div>

                        </div>

                    ))
                }

            </div>

            {
                showModal
                && editItem && (

                    <div
                        className="modal-overlay"
                    >

                        <div
                            className="modal-box"
                        >

                            <h3>
                                게시물 수정
                            </h3>

                            <label>
                                제목
                            </label>

                            <input
                                value={
                                    editItem.title
                                }
                                onChange={(e) =>
                                    setEditItem({

                                        ...editItem,

                                        title:
                                        e.target.value
                                    })
                                }
                            />

                            <label>
                                카테고리
                            </label>

                            <input
                                value={
                                    editItem.category
                                }
                                onChange={(e) =>
                                    setEditItem({

                                        ...editItem,

                                        category:
                                        e.target.value
                                    })
                                }
                            />

                            <label>
                                내용
                            </label>

                            <textarea
                                value={
                                    editItem.content
                                }
                                onChange={(e) =>
                                    setEditItem({

                                        ...editItem,

                                        content:
                                        e.target.value
                                    })
                                }
                            />

                            <div
                                className="modal-buttons"
                            >

                                <button
                                    className="edit-btn"
                                    onClick={
                                        handleSave
                                    }
                                >
                                    저장
                                </button>

                                <button
                                    className="delete-btn"
                                    onClick={() => {

                                        setShowModal(
                                            false
                                        );

                                        setEditItem(
                                            null
                                        );

                                    }}
                                >
                                    취소
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>
    );
};

export default AppContentManage;